import { css } from "@emotion/css";

import { yellow } from "@/modules/theme/utils/colors";

export function createSubtaskDetailsPageStyles() {
  return {
    loaderWrapper: css({
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      color: yellow[400],
      width: "100%",
      minHeight: 400,
    }),
    headingSkeleton: css({
      maxWidth: 350,
    }),
  };
}
